<div fxFlex="1 1 100%" fxLayout="row" [ngClass]="{'confirmModal' : usedInApp}" fxLayout.lt-md="column"
  class="confirm-staff-container">
  <div *ngIf="retrieveInitialData; else loader;" fxLayout="column" fxFlex="1 1 100%" class="confirm-staff-wrapper">
    <div fxLayout="row">
      <label class="header">Let’s double check our work.</label>
    </div>
    <div fxLayout="row">
      <label class="subtitle">You are can make any changes to your staff list. Just <strong>edit</strong> or
        <strong>remove</strong>.</label>
    </div>
    <app-manual-add [showAddAnother]="false" [shownInApp]="usedInApp" (activeStaff)="getUpdatedData($event)"
      (validState)="isValidState = $event"></app-manual-add>
    <div class="state-buttons" fxFlex="0 0 auto" fxHide.gt-sm fxLayout="row">
      <!--SAVE WILL SHOW WHEN THERE ARE CHANGES; ON MOBILE WILL SHOW UNDER AND HIDE ON DISPLAY -->
      <app-schedule-creation-state-buttons *ngIf="!usedInApp" [hideSave]="!isChanged" (forwardStateChange)="goForward()"
        [validBackBtn]="true" [validNextBtn]="!!isValidState" fxFlex="0 0 100%" (saveButtonClicked)="saveChanges()">
      </app-schedule-creation-state-buttons>
    </div>
  </div>
</div>

<app-schedule-creation-state-buttons *ngIf="!usedInApp" fxHide.lt-md [hideSave]="!isChanged"
  (forwardStateChange)="goForward()" [validBackBtn]="true" [validNextBtn]="!!isValidState"
  (saveButtonClicked)="saveChanges()">
</app-schedule-creation-state-buttons>
<div *ngIf="usedInApp" fxLayout="row" class="fixedPosition" fxLayoutAlign="space-between center">
  <div fxLayout="column" class="checkbox-container">
    <mat-checkbox [checked]="false" (change)="updateSendText($event.checked)" automation-id="continue-the-set-up-account-confirm-staff">
      Send a text invitation to your staff to set up an account now.</mat-checkbox>

  </div>
  <div fxLayout="column" class="button-container">
    <button class="icare-secondary-icon-button" (click)="goBack()" mat-button automation-id="back-button-confirm-staff">Back</button>
    <button class="icare-primary-button" mat-button (click)="saveChanges()" automation-id="finish-button-confirm-staff">Finish</button>
  </div>

</div>
<ng-template #loader>
  <div class="loader">
    <img fxFlex="0 1 70px" src="../../../../assets/images/loader.gif" height="70" width="70" />
  </div>
</ng-template>